import {NewPortModel, PortModel} from "../models/ports";
import http from "../../common/services/httpService";
import {Api, apiUrls, SortingAndFilteringParams} from "../../helpers/api";
import {PageableModel} from "../../common/models/table";
import {AxiosPromise, AxiosResponse} from "axios";
import { HttpErrorModel } from "../../common/models/httpError";

export class PortService {
    private static basicUrl = apiUrls.dictionaries.ports;

    public static async getAll(sortingAndFilteringParams?: SortingAndFilteringParams): Promise<AxiosResponse<PageableModel<PortModel>>> {
        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.basicUrl), sortingAndFilteringParams);
        return await http.get<PageableModel<PortModel>>(url);
    }

    public static async getPort(id: string): Promise<AxiosResponse<PortModel>> {
        return await http.get(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async addPort(data: NewPortModel): Promise<AxiosPromise> {
        return await http.post(Api.getUrl(this.basicUrl), data);
    }

    public static async removePort(id: string): Promise<AxiosResponse> {
        return await http.delete(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async modifyPort(data: NewPortModel, id: string): Promise<AxiosResponse<HttpErrorModel[]|any>> {
        return await http.post(`${Api.getUrl(this.basicUrl)}/${id}`, data);
    }
}
